import React from "react"

import Layout from "../../components/layout"
import SEO from "../../components/seo"
import Fem from "../../components/Portfolio/Fem"

const FemPage = ({ location }) => (
  <Layout location={location}>
    <SEO title="Home" keywords={[`BMR`, `labels`]} />
    <Fem />
  </Layout>
)

export default FemPage
